import { RootState } from '../store/configureStore';

export const getPricelist = (state: RootState) => state?.priceLists.prices ?? [];

export const isFetchingPricelist = (state: RootState) =>
    state?.priceLists?.isFetchingPrices;

export const didFetchingPricelistFailed = (state: RootState) =>
    state?.priceLists?.fetchingPricesFailed;
